import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	fill: "#222",
	fillRule: "evenodd",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "translate(8, 5)",
		d: "M6 .586a1 1 0 011.497 1.32L7.414 2l-5 4.999 5 5.001a1 1 0 01.083 1.32l-.083.094a1 1 0 01-1.32.083L6 13.414.293 7.707a1 1 0 01-.083-1.32l.083-.094L6 .586z"
	})
});
export default SvgChevronLeft;
